<template>
  <div :class="{ 'messages-list--dense': dense, 'messages-list--loading': loading }" class="messages-list">
    <div class="messages-list__loading">
      <v-progress-circular indeterminate color="primary" />
    </div>
    <div v-for="group in items" :key="group.groupDate" class="messages-list__group">
      <div class="messages-list__group-date">{{ group.groupDate | dateFormat('MESSAGE_GROUP_DATE') }}</div>
      <div
        v-for="message in group.messages"
        :key="message.createdAt"
        :class="[ `messages-list__item--${message.type}`, {
          'messages-list__item--owner': message.isOwner,
          'messages-list__item--show-avatar': message.showAvatar,
          'messages-list__item--right': message.type === 'system' || message.isOwner,
        }]"
        class="messages-list__item">
        <div class="messages-list__item__avatar">
          <v-img
            :src="message.profilePicture || require('@/assets/images/default-avatar.png')"
            @error="message.profilePicture = require('@/assets/images/default-avatar.png')" />
        </div>
        <div class="messages-list__item__content">
          <div class="messages-list__item__top">
            <span v-if="message.date" class="messages-list__item__date">{{ message.date | dateFormat('MESSAGE_DATE') }}</span>
            <span v-if="!message.isSystem && message.username" class="messages-list__item__owner">
              {{ message.username }}
            </span>
          </div>
          <div class="messages-list__item__text">
            <v-icon v-if="message.type === 'system'" color="white">$bell</v-icon>
            {{ message.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessagesList',
  props: {
    items: {
      type: Array,
      default: null,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};

// 1. різні колонки на сторінці енролмент
// 2. Добавили юзенрнейм але потрібно добавити fullName
//
</script>

<style lang="scss">
  @import "src/assets/style/lists/MessagesList";
</style>
